import React from 'react';
import { ErrorBoundary } from '@/components/error-boundary';

interface AppErrorBoundaryProps {
  children: React.ReactNode;
}

export function AppErrorBoundary({ children }: AppErrorBoundaryProps) {
  const handleError = (error: Error, errorInfo: any) => {
    // Log to monitoring service in production
    console.error('Application-level error:', error, errorInfo);
    
    // Send to analytics/monitoring service
    if (process.env.NODE_ENV === 'production') {
      // Example: Sentry, LogRocket, etc.
      // Sentry.captureException(error, { contexts: { errorInfo } });
    }
  };

  return (
    <ErrorBoundary
      level="critical"
      onError={handleError}
    >
      {children}
    </ErrorBoundary>
  );
}
